module.exports = __webpack_public_path__ + "img/profile.58c0635e.jpg";